exports.makeEntryPath = (entry) => {
  return "/" + entry.slug + "/";
}